import React from 'react'

const DoubleWindowError = () => {
    return (
              <div style={{display: "flex",justifyContent: "center", alignItems: "center", height: "100%",fontSize: "3em",fontWeight: "bold",color:"red"}}>
                KAN INTE HA FLERA FÖNSTER ÖPPNADE SAMTIDIGT! STÄNG DETTA
              </div>
    )
} 


export default DoubleWindowError;










